<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="3">
                <div class="Agen">
                  <label for="filterAgen">Seller</label>
                  <model-select
                    class="form-control"
                    id="filterAgen"
                    :options="agentList"
                    v-model="filter.agent"
                    placeholder="-- ALL --"
                  ></model-select>
                </div>
              </CCol>

              <CCol lg="3">
                <div class="Agen">
                  <label for="filterStatus">Status</label>
                  <model-select
                    class="form-control"
                    id="filterStatus"
                    :options="statusList"
                    v-model="filter.status"
                    placeholder="-- ALL --"
                  ></model-select>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12">
                <br />
                <CButton size="sm" @click="searching" color="info">
                  <i class="fa fa-search"></i>
                  Filter
                </CButton>
                &nbsp;
                <CButton size="sm" @click="clearFilter" color="danger">
                  <i class="fa fa-undo"></i>
                  Clear
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columngroups="fieldsgroup"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol sm="6">
              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Produk Name"
                    invalid-feedback="Name should be filled"
                    required
                    v-model="$v.productForm.name.$model"
                    :is-valid="!$v.productForm.name.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CInput
                    label="Title"
                    invalid-feedback="Title should be filled"
                    required
                    placeholder="e.g Kalimat promosi untuk di share"
                    v-model="$v.productForm.title.$model"
                    :is-valid="!$v.productForm.title.$invalid"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <div class="product-group">
                    <label for="product_group">Product Group</label>
                    <model-select
                      class="form-control"
                      id="product_group"
                      :options="groupList"
                      v-model="$v.productForm.group.$model"
                      :isError="$v.productForm.group.$invalid"
                      @input="filterParentCategory"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.productForm.group.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Product Group should be filled.
                    </div>
                  </div>
                </CCol>

                <CCol sm="6">
                  <div class="parent-category">
                    <label for="parent_category">Category</label>
                    <model-select
                      class="form-control"
                      id="parent_category"
                      :options="parentCategoryList"
                      v-model="$v.productForm.parent_category.$model"
                      :isError="$v.productForm.parent_category.$invalid"
                      @input="filterCategory"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.productForm.parent_category.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Category should be filled.
                    </div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <div class="sub-category">
                    <label for="sub_category">Sub Category</label>
                    <model-select
                      class="form-control"
                      id="sub_category"
                      :options="categoryList"
                      v-model="$v.productForm.category.$model"
                      :isError="$v.productForm.category.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.productForm.category.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Sub Category should be filled.
                    </div>
                  </div>
                </CCol>
                <CCol sm="6">
                  <div class="Agen">
                    <label for="agen">Seller</label>
                    <model-select
                      class="form-control"
                      id="agen"
                      :options="agentList"
                      v-model="$v.productForm.agent_code.$model"
                      :isError="$v.productForm.agent_code.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.productForm.agent_code.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Seller should be filled.
                    </div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <CInput
                    type="number"
                    label="Quantity"
                    min="0"
                    invalid-feedback="Quantity"
                    required
                    v-model="$v.productForm.quantity.$model"
                    :is-valid="!$v.productForm.quantity.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <div class="product_unit">
                    <label for="product_unit">Produk Unit</label>
                    <model-select
                      class="form-control"
                      id="product_unit"
                      :options="productUnitList"
                      v-model="$v.productForm.product_unit.$model"
                      :isError="$v.productForm.product_unit.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.productForm.product_unit.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Product unit should be filled.
                    </div>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol sm="6">
                  <CInput
                    label="Brand"
                    invalid-feedback="Brand should be filled"
                    v-model="$v.productForm.brand.$model"
                    :is-valid="!$v.productForm.brand.$invalid"
                  />
                </CCol>
                <CCol sm="6">
                  <CInput
                    label="Packaging Size"
                    invalid-feedback="Packaging Size should be filled"
                    v-model="$v.productForm.packaging_size.$model"
                    :is-valid="!$v.productForm.packaging_size.$invalid"
                  />
                </CCol>
              </CRow>
            </CCol>

            <CCol sm="6">
              <CRow>
                <CCol sm="12">
                  <label for="nik">Description</label>
                  <quill-editor
                    style="height: 200px; margin-bottom: 70px"
                    :content="content"
                    :options="editorOption"
                    v-model="$v.productForm.description.$model"
                    @change="onEditorChange($event)"
                  >
                  </quill-editor>
                  <br />
                  <div
                    v-if="$v.productForm.description.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Description harus di isi.
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.productForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import Loading from "@/templates/Loading";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Products",
  components: { Loading, quillEditor, JqxGrid, TableButton },
  data() {
    return {
      title: "Produk",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "product_code", type: "string" },
          { name: "name", type: "string" },
          { name: "group_name", type: "string" },
          { name: "parent_category_name", type: "string" },
          { name: "category_name", type: "string" },
          { name: "brand", type: "string" },
          { name: "agent_code", type: "string" },
          { name: "agent_name", type: "string" },
          { name: "status_name", type: "string" },
          { name: "quantity", type: "float" },
          { name: "product_unit_name", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,
      fields: [
        {
          datafield: "product_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode Produk",
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Produk",
        },
        {
          datafield: "group_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Grup",
        },
        {
          datafield: "parent_category_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kategori Utama",
        },
        {
          datafield: "category_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kategori",
        },
        {
          datafield: "agent_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode Seller",
        },
        {
          datafield: "agent_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Seller",
        },
        {
          datafield: "brand",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Brand",
          hidden: true,
        },
         {
          datafield: "quantity",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Satuan Kemasan",
          cellsalign: "right",
          hidden: true,
        },
         {
          datafield: "product_unit_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Satuan Produk",
          hidden: true,
        },
        {
          datafield: "status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
        },
        {
          text: "Edit",
          columngroup: "ActionsGroup",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
        {
          text: "Copy",
          columngroup: "ActionsGroup",
          align: "center",
          name: "CopyAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Copy";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            this.cloneProduct(dataRecord);
          },
        },
      ],

      fieldsgroup: [
        {
          text: "Actions",
          align: "center",
          name: "ActionsGroup",
        },
      ],
      listBoxSource: [
        {
          label: "Brand",
          value: "brand",
          checked: false,
        },
        {
          label: "Satuan Kemasan",
          value: "quantity",
          checked: false,
        },
        {
          label: "Satuan Produk",
          value: "product_unit_name",
          checked: false,
        },
      ],

      productForm: tableInterfaces.products,
      items: null,
      parentCategoryList: [],
      categoryList: [],
      groupList: [],
      agentList: [],
      statusList: [],
      tempParentCategoryList: [],
      tempCategoryList: [],
      productUnitList: [],
      isLoading: false,
      isEdit: false,
      addButton: false,
      content: "",
      editorOption: {}, // data quill
      filter: {
        agent: null,
        status: null,
      },
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    productForm: {
      agent_code: { required },
      group: { required },
      parent_category: { required },
      category: { required },
      name: { required },
      title: { required },
      description: { required },
      quantity: { required },
      product_unit: { required },
      images: {},
      brand: {},
      packaging_size: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    is_agent: function () {
      const agent = localStorage.getItem("is_agent");
      return agent === "true" ? true : false;
    },
  },
  methods: {
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getDropdown();
      this.getProductListing();
    },
    filterParentCategory: function (event) {
      this.parentCategoryList = this.tempParentCategoryList.filter(
        (x) => x.group === this.productForm.group
      );
      this.productForm.category = null;
      this.productForm.parent_category = null;
    },
    filterCategory: function (event) {
      this.categoryList = this.tempCategoryList.filter(
        (x) => x.parent === this.productForm.parent_category
      );
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/products").then((response) => {
        this.groupList = response.data.group;
        this.tempCategoryList = response.data.category;
        this.tempParentCategoryList = response.data.parent_category;
        this.agentList = response.data.agent;
        this.productUnitList = response.data.product_unit;
        this.statusList = response.data.product_status;
      });
    },
    getProductListing: function (filtering = {}) {
      this.isLoading = true;
      this.axios
        .post("console/products/listing", filtering)
        .then((response) => {
          if (response.data.status === 2000) {
            //console.log(response.data)
            // this.items = response.data.data;

            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.productForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.products) {
        tableInterfaces.products[i] = null;
      }
      this.productForm = tableInterfaces.products;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this product ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/products/add", this.productForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({
                path: path[2] + "/detail/" + response.data.id,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    cloneProduct: function(data) {
       if (confirm("Are you sure want to copy this product ?")) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/products/copy-product", data)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
                console.log(response.data.data);
                this.$router.push({
                  path: path[2] + "/detail/" + response.data.data.id,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
       }
    },
    searching: function () {
      this.getProductListing(this.filter);
    },
    clearFilter: function () {
      this.filter = {
        agent: null,
        status: null,
      };
      this.getProductListing(this.filter);
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.productForm.description = html;
    }
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
